import { BettyHistoryModuleType } from "UidispatcherApiModule";
const { BettyHistoryModule }: { BettyHistoryModule: BettyHistoryModuleType } =
    // @ts-expect-error
    await import("uidispatcher_api/UidispatcherApiModule");

export default BettyHistoryModule;
